// @flow

import Resource from 'speed-js-core/src/api/Resource';
import type { UUID } from 'esm-web-pro/types/common';

export default class CableResource extends Resource {
    basePath: string = 'networks/cables/';

    objectPath: string = 'networks/cables/{ident}/';

    path(id: string, params: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}path/`,
            'GET',
            params,
        ).then((response) => response.data);
    }

    /**
     * @param {string} id  UUID of the cable
     * @param {object} data contains only one key: point, with the UUID of the point in which the cable is split
     * @returns {Promise<Object>} data of the newly created cables
     */
    split(id: UUID, data: { point: UUID }): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}split/`,
            'POST',
            data,
        ).then((response) => response.data);
    }

    getCableLinesForPaths(id: UUID, params: { paths: Array<integer>, map: UUID }): Promise<Object> {
        return this.client._request(
            `${this._getObjectPath(id)}available_paths/`,
            'GET',
            params,
        ).then((response) => response.data);
    }
}
